export default __webpack_public_path__ + "static/good-shopping-3e4a220411453f0572967e03bcfb91c6.webp";